import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {FC} from 'react'

import {STATIC_CONTENT_WIDTH} from '@/theme/sizing'
import {LegalDocumentationContent} from '@/utils/contentful'
import {withSequentialHeadingLevels} from '@/utils/contentful/headingLevels'

import {Section} from '../common/content/Section'
import {Hero} from '../common/hero/Hero'
import {Page} from '../Page'
import {options} from './styledLegalDocumentation'

type LegalDocumentationPageProps = {
  content: LegalDocumentationContent
}

export const LegalDocumentationPage: FC<LegalDocumentationPageProps> = ({content}) => {
  const {title, subtitle, text} = content

  return (
    <>
      <Page>
        <Hero title={title} subtitle={subtitle} isCentered />
        <Section hasPaddingTop hasPaddingBottom>
          <div className="content">
            {documentToReactComponents(withSequentialHeadingLevels(text), options)}
          </div>
        </Section>
      </Page>

      <style jsx>{`
        .content {
          max-width: ${STATIC_CONTENT_WIDTH};
          margin: 0 auto;
        }
      `}</style>
    </>
  )
}
